/**
 * 全局 message 和 notification 实例管理器
 * 用于在非组件环境（如请求拦截器）中使用 antd 的 message/notification
 */
import type { MessageInstance } from 'antd/es/message/interface';
import type { NotificationInstance } from 'antd/es/notification/interface';

let messageInstance: MessageInstance;
let notificationInstance: NotificationInstance;

export const setMessageInstance = (instance: MessageInstance) => {
  messageInstance = instance;
};

export const setNotificationInstance = (instance: NotificationInstance) => {
  notificationInstance = instance;
};

export const getMessageInstance = () => messageInstance;
export const getNotificationInstance = () => notificationInstance;
